import { render, staticRenderFns } from "./ServersDetails.vue?vue&type=template&id=c64c1bac&scoped=true&"
import script from "./ServersDetails.vue?vue&type=script&lang=js&"
export * from "./ServersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServersDetails.vue?vue&type=style&index=0&id=c64c1bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64c1bac",
  null
  
)

component.options.__file = "ServersDetails.vue"
export default component.exports